import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddLocationComponent } from '../add-location/add-location.component';
import { JobService } from 'src/app/services/job/job.service';
import { CommonService } from 'src/app/services/common/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';

@Component({
  selector: 'app-company-location',
  templateUrl: './company-location.component.html',
  styleUrls: ['./company-location.component.scss']
})
export class CompanyLocationComponent {
  panelOpenState = false;
  public companyLocArr :any[]= [];
  constructor(private dialog: MatDialog,private jobService:JobService,private commonService:CommonService,private spinner:NgxSpinnerService) { }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.list();
  }
  onAddLocation() {
    const dialogRef = this.dialog.open(AddLocationComponent, {
      width: '75%',
      minWidth: '300px',
      height: '98%',
      maxHeight: '690px', maxWidth: '800px',
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result && result["confirm"]=='yes'){
        this.list()
      }
    });
  }
  list(){
    let data={
      need:2  // 1 = company list, 2 = address with company list
    }
    this.spinner.show()
    this.jobService.viewCompanyLocation(data).subscribe({
      next: (success: Object) => {
        this.spinner.hide();
        if (success["status"] == 200) {
          this.companyLocArr=[]
          this.companyLocArr=success["msg"]
        }
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error);
      },
    });
  }
  onDeleteItem(co_i:string,add_i:string) { 
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: { api_type: "delete_content", content_type: "delete_address", id: co_i, add_i:add_i }
    },));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        this.list()
      }
    });
  }
} 
